import { init, track, setUserId as amplitudeSetUserId } from '@amplitude/analytics-browser';
import { sessionReplayPlugin } from '@amplitude/plugin-session-replay-browser';

const AMPLITUDE_API_KEY = process.env.REACT_APP_AMPLITUDE_API_KEY;

const isProd = process.env.NODE_ENV === 'production';

let isInitialized = false;
let globalUserId = null;

// Supabase OAuth redirects land on /#access_token=<jwt>; autocaptured page views would
// otherwise store that token (and the email/name inside it) in the analytics event log
const stripUrlHash = {
  name: 'strip-url-hash',
  type: 'enrichment',
  setup: async () => {},
  execute: async (event) => {
    const props = event.event_properties;
    if (props) {
      for (const key of ['[Amplitude] Page URL', '[Amplitude] Page Location']) {
        if (typeof props[key] === 'string' && props[key].includes('#')) {
          props[key] = props[key].split('#')[0];
        }
      }
    }
    return event;
  },
};

export const initializeAmplitude = (userId) => {
  if (isProd && !isInitialized) {
    init(AMPLITUDE_API_KEY, {
      defaultTracking: {
        sessions: true,
        pageViews: true,
        formInteractions: true,
        fileDownloads: true,
      },
      plugins: [
        stripUrlHash,
        sessionReplayPlugin({
          sampleRate: 1,
        }),
      ],
    });
    isInitialized = true;
  }
  if (userId) {
    setAmplitudeUserId(userId);
  }
};

export const setAmplitudeUserId = (userId) => {
  if (isProd) {
    amplitudeSetUserId(userId);
  }
  globalUserId = userId;
};

export const logEvent = (eventName, eventProperties = {}) => {
  const enhancedProperties = {
    ...eventProperties,
    userId: globalUserId,
  };

  if (isProd) {
    track(eventName, enhancedProperties);
  } else {
    console.log('Event logged (DEV):', eventName, enhancedProperties);
  }
};

// Google Ads conversion actions (Goals > Conversions in the Ads account)
export const ADS_CONVERSIONS = {
  accountCreated: 'AW-16730896633/GXdNCNj42pEdEPnx9Kk-',
  purchaseCompleted: 'AW-16730896633/0hD8CNv42pEdEPnx9Kk-',
};

// Log a conversion to Amplitude and report it to Google Ads, so ad campaigns can optimise for it
// Meta standard events for our conversions; the Stripe webhook sends the money ones
// server-side too, deduplicated by event id
const META_EVENTS = {
  'Account Created': 'CompleteRegistration',
  'Trial Started': 'StartTrial',
  'Subscription Purchase Completed': 'Purchase',
  'Top Up Purchase Completed': 'Purchase',
};

export const logConversion = (eventName, adsConversion, params = {}) => {
  const { email, ...eventParams } = params;
  logEvent(eventName, eventParams);
  if (!isProd) return;
  const { value, currency, transaction_id } = params;
  if (typeof window.gtag === 'function') {
    // Enhanced conversions: the hashed email lets Ads match a purchase to a YouTube
    // in-app click whose URL parameters and cookies did not survive the round trip
    if (email) window.gtag('set', 'user_data', { email });
    window.gtag('event', 'conversion', { send_to: adsConversion, value, currency, transaction_id });
  }
  const metaEvent = META_EVENTS[eventName];
  if (metaEvent && typeof window.fbq === 'function') {
    const data = value ? { value, currency: currency || 'USD' } : {};
    window.fbq('track', metaEvent, data, transaction_id ? { eventID: transaction_id } : undefined);
  }
};
